/*
 * @@Description: group-table
 * @@Author: MuYang
 * @Date: 2021-07-28 10:57:30
 * @LastEditTime: 2021-10-22 16:56:03
 */
import T from './components/index'
import { TableProps } from './util/default-props'
import { PREFIX } from './util/config'
import openEvent from './mixin/open-event'
const SLOTNAME = 'groupTitle'
export default {
  name: 'GTable',
  components: {
    T
  },
  props: TableProps,
  mixins: [openEvent],
  methods: {
    normalizeSlot (slots, scopedSlots) {
      let renderChild
      if (slots[SLOTNAME]) {
        renderChild = slots[SLOTNAME]
      } else if (scopedSlots[SLOTNAME]) {
        renderChild = scopedSlots[SLOTNAME]
      }
      return payload => typeof renderChild === 'function' ? renderChild(payload) : renderChild
    }
  },
  render (h) {
    // 初始化
    const { $scopedSlots, $slots, $props, dataSource } = this
    const groupTitleRender = this.normalizeSlot($scopedSlots, $slots)
    const tProps = {
      props: {
        ...$props,
        dataSource,
        // renderType: 'definition',
        groupTitleRender
      },
      class: `${PREFIX}-group`,
      scopedSlots: $scopedSlots
    }
    return <T {...tProps}>{$slots}</T>
  }
}
